import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';
import Grid from '@mui/material/Grid2';
import { Box, Card, Stack } from '@mui/material';
import { API_CASINO } from '../../../../../api/casino';
import useNumberParams from '../../../../../hooks/useNumberParams';
import useToast from '../../../../../hooks/useToast';
import useBootstrapSize from '../../../../../hooks/useBootstrapSize';
import CurrentBanner from './CurrentBanner';
import CasinoBtnSave from '../../../../../components/casino/CasinoBtnSave';
import TabsLanguage from '../../../../../components/widgets/TabsLanguage';

export default function BannerContent() {
  const { t } = useTranslation();
  const { langCode } = useParams();
  const { isLessTablet } = useBootstrapSize();
  const { successToast } = useToast();
  const casinoId = useNumberParams('casinoId');

  const [bannerStruct, setBannerStruct] = useState({});

  const banners = [
    {
      id: 'main',
      title: 'Bonus banner in the homepage slider',
      desktop: { id: 'ImageMainWindowDesktop', label: 'Desktop' },
      mobile: { id: 'ImageMainWindowMobile', label: 'Mobile' },
      footer: 'The dimensions must match the dimensions of the banner in the slider'
    },
    {
      id: 'menu',
      title: 'Menu bonuses',
      desktop: { id: 'ImgMenuBonusDesktop', label: t('Desktop') + ' (600x340)' },
      mobile: { id: 'ImgMenuBonusMobile', label: t('Mobile') + ' (360x360)' }
    },
    {
      id: 'login',
      title: 'Banners for login window',
      desktop: { id: 'ImgLoginDesktop', label: t('Desktop') + ' (396x668)' },
      mobile: { id: 'ImgLoginMobile', label: t('Mobile') + ' (656x326)' }
    },
    {
      id: 'signup',
      title: 'Banners for registration window',
      desktop: { id: 'ImgRegistrationDesktop', label: t('Desktop') + ' (396x668)' },
      mobile: { id: 'ImgRegistrationMobile', label: t('Mobile') + ' (656x326)' }
    }
  ];

  useEffect(() => {
    API_CASINO.banners
      .list({ casinoId })
      .then((e) => {
        const list = e.data.list;
        setBannerStruct(list);
      })
      .catch(console.error);
  }, [casinoId]);

  const onSaveClick = () => {
    for (let lang in bannerStruct) {
      const curStruct = bannerStruct[lang];
      for (let bannerType in curStruct) {
        const curInfo = curStruct[bannerType];
        delete curInfo.base64Full;
      }
    }

    API_CASINO.banners
      .set({ casinoId, list: bannerStruct })
      .then((e) => {
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  return (
    <Stack gap={2}>
      <TabsLanguage
        lang={langCode}
        component={Link}
        goTo={(tab) => `/casino/design/banners/${casinoId}/${tab.lang}`}
      />

      <Box display={'flex'} gap={1} key={'banner_' + langCode}>
        <Card sx={{ p: 0 }}>
          <Box gap={2} display={'flex'} flexDirection="column">
            <Grid
              container
              spacing={{ xs: 5, sm: 2 }}
              sx={
                isLessTablet ? undefined : { maxHeight: 'calc(100svh - 340px)', overflow: 'auto' }
              }>
              {banners.map((banner, indx) => {
                const bannerId = banner.id;
                const desktopFile = bannerStruct?.[langCode]?.[bannerId]?.desktop;
                const mobileFile = bannerStruct?.[langCode]?.[bannerId]?.mobile;

                return (
                  <CurrentBanner
                    key={'banner_' + indx}
                    desktopFile={desktopFile}
                    mobileFile={mobileFile}
                    langCode={langCode}
                    banner={banner}
                    setBannerStruct={setBannerStruct}
                  />
                );
              })}
            </Grid>

            <CasinoBtnSave onClick={onSaveClick} />
          </Box>
        </Card>
      </Box>
    </Stack>
  );
}
